import { Layout } from 'antd';
import { Content, Footer } from 'antd/es/layout/layout';
import Sider from 'antd/es/layout/Sider';
import React from 'react';
import HomeContent from './HomeContent';
import "../../../src/website.css";
import { useMediaQuery } from 'react-responsive'
import HomeFooter from './HomeFooter';
import { ScrollRestoration } from 'react-router-dom';

const Homepage = () => {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    return (
        <Layout>
             <ScrollRestoration />
            <Layout>
                <Content style={{ paddingRight: isTabletOrMobile ? 22 : 80, paddingLeft: isTabletOrMobile ? 22 : 80, paddingBottom: 24 }}>
                    <HomeContent isTabletOrMobile={isTabletOrMobile} />
                </Content>
            </Layout>
            <Footer style={{ padding: 0, paddingTop: 30 }}>
                <HomeFooter isTabletOrMobile={isTabletOrMobile} />
            </Footer>
        </Layout>
    );
}

export default Homepage;